import { $, $$ } from "./$.module"

const string = function (str: string): HTMLElement | null {
  if (['#','.'].includes(str.substring(0, 1))) {
    return $(str);
  } else {
    return $(`#${str}`);
  }
  return null;
}

const strings = function (str: string): Array<HTMLElement> | null {
  if (['#','.'].includes(str.substring(0, 1))) {
    return $$(str);
  } else {
    return $$(`.${str}`);
  }
  return null;
}

const object = function (obj: HTMLElement | Array<HTMLElement> | Array<string> | NodeList | HTMLCollection): HTMLElement | null {
  if (obj instanceof HTMLElement) {
    return obj
  } else if (obj instanceof HTMLCollection) {
    const c: HTMLCollection = obj
    return c.item(0) as HTMLElement

  } else if (obj instanceof NodeList) {
    const o: NodeList = obj
    return o.item(0) as HTMLElement;
  }
  return null;
}

const objects = function (objs: HTMLElement | Array<HTMLElement> | Array<string> | NodeList | HTMLCollection): Array<HTMLElement> | null {
  if (objs instanceof HTMLElement) {
    return [objs] as Array<HTMLElement>;
  }
  const os = [...objs];
  const ret: Array<HTMLElement> = []
  os.forEach(element => {
    ret.push(object(element as HTMLElement) as HTMLElement)
  });
  return ret;
}

const getElements = function (els: string | HTMLElement | Array<HTMLElement> | Array<string> | NodeList | HTMLCollection): Array<HTMLElement> | null {
  const t = typeof els;
  switch (t) {
    case 'string':
      return strings(els as string)
    case 'object':
      return objects(els as HTMLElement | Array<HTMLElement> | Array<string> | NodeList | HTMLCollection);
  }
  return [];
}

const getElement = function (el: String | HTMLElement | NodeList | HTMLCollection): HTMLElement | null{
  const t = typeof el;
  switch (t) {
    case 'string':
      return string(el as string);
    case 'object':
      return object(el as object);
  }
  return null;
}

export {getElement, getElements}
